import { render } from "./App.vue?vue&type=template&id=6f6215c0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=6f6215c0&lang=css"

import exportComponent from "G:\\Eatura Dashboard\\Dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__